import { render, staticRenderFns } from "./TabNavBar.vue?vue&type=template&id=4096dbc3&"
import script from "./TabNavBar.vue?vue&type=script&lang=js&"
export * from "./TabNavBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports